import api from "./api";

/** GET /countries — public list of active countries. */
export const fetchCountries = async () => {
  const { data } = await api.get("/countries");
  return data.data.countries;
};

/** GET /countries/{id}/cities — active cities of one country. */
export const fetchCities = async (countryId) => {
  const { data } = await api.get(`/countries/${countryId}/cities`);
  return data.data.cities;
};

/** GET /currencies — public list of active currencies. */
export const fetchCurrencies = async () => {
  const { data } = await api.get("/currencies");
  return data.data.currencies;
};

/** GET /business/stats — headline counts for the home page. */
export const fetchBusinessStats = async () => {
  const { data } = await api.get("/business/stats");
  return data.data.stats;
};

/** GET /business/profile — the business with its types and branches. */
export const fetchBusinessProfile = async () => {
  const { data } = await api.get("/business/profile");
  return data.data.business;
};

/** GET /business/business-types — the types this business may file branches under. */
export const fetchBusinessTypes = async () => {
  const { data } = await api.get("/business/business-types");
  return data.data.business_types;
};

/**
 * GET /business/users — the staff a branch manager can be picked from.
 *
 * OUP-26 — deliberately unfiltered. This once sent `only_branch_managers=1`,
 * which emptied the dropdown for any business whose Branch Manager role was
 * still unheld; the endpoint that consumes the choice
 * (PUT /business/branches/{id}/manager) accepts any user of the business and
 * gives them the role, so narrowing the list here only hid valid candidates.
 * The parameter the API still offers is left unsent rather than passed as 0.
 */
export const fetchBusinessUsers = async () => {
  const { data } = await api.get("/business/users", { params: { per_page: 100 } });
  return data.data.users;
};
